import { CategoryData, PageMappingData, PlanData } from "types/models/planMaster/planMasterApp"

export const planData: PlanData[] = [
 
]
export const categoryData: CategoryData[] = [
  {
    sNo: 1,  
    categoryName: "Nimbl",
    categoryIndex: 1,
    categoryUrl: 	"/broadband-internet-nimbl-tariff-price-plans",
    status:"Active",
  },
  {
    sNo: 2,  
    categoryName: "Simpl",
    categoryIndex: 3,
    categoryUrl: 	"/broadband-internet-simpl-tariff-price-plans",
    status:"Active",
  },
  {
    sNo: 3,  
    categoryName: "	Ampl",
    categoryIndex: 2,
    categoryUrl: 	"	/broadband-internet-ampl-tariff-price-plans",
    status:"Active",
  },
  {
    sNo: 4,  
    categoryName: "Nimbl",
    categoryIndex: 4,
    categoryUrl: 	"	/long-duration-broadband-plans/ampl",
    status:"Active",
  },
  {
    sNo: 5,  
    categoryName: "	LDP-Simpl",
    categoryIndex: 5,
    categoryUrl: 	"	/long-duration-broadband-plans/simpl",
    status:"Active",
  },
  {
    sNo: 6,  
    categoryName: "	LDP-Nimbl",
    categoryIndex: 6,
    categoryUrl: 	"	/long-duration-broadband-plans/nimbl",
    status:"Active",
  },
  
]
export const pageMappingData: PageMappingData[] = [
  {
    sNo: 1,  
    planCode: "Super200N12M_eocprepaid",
    planName: "Super_12M 200N",
    pagesName: 	"",
    action:"map",
  },
  {
    sNo: 2,
    planCode: "SUPRM200X_eocprepaid",
    planName: "Supreme 200K",
    pagesName: 	"marketing",
    action:"map",
  },
  {
    sNo: 3,
    planCode: "NML100X_eocprepaid",
    planName: "Nimbl 100X",
    pagesName: 	"",
    action:"map",
  },
  {
    sNo: 4,
    planCode: "	NML100X3M_eocprepaid",
    planName: "	Nimbl 100X",
    pagesName: 	"",
    action:"map",
  },
  {
    sNo: 5,
    planCode: "NML100X6M_eocprepaid",
    planName: "	Nimbl 100X",
    pagesName: 	"",
    action:"map",
  },
  {
    sNo: 6,
    planCode: "	NML100X12M_eocprepaid",
    planName: "	Nimbl 100X",
    pagesName: 	"",
    action:"map",
  },
  {
    sNo: 7,
    planCode: "AMPL30X_eocprepaid",
    planName: "Ampl 50X",
    pagesName: 	"marketing",
    action:"map",
  },
  {
    sNo: 8,
    planCode: "	NML30X_eocprepaid",
    planName: "Nimbl 50X",
    pagesName: 	"",
    action:"map",
  },
  {
    sNo: 9,
    planCode: "	AMPL30X3M_eocprepaid",
    planName: "	Ampl 50X",
    pagesName: 	"	marketing",
    action:"map",
  },
]